/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { QueryRef } from '@apollo/client/react'
import { createFileRoute } from '@tanstack/react-router'
import AdminReportCasePanel from '@web/src/features/admin/admin-report-case-panel/admin-report-case-panel'
import { ADMIN_REPORT_CASE_QUERY } from '@web/src/features/admin/admin-reports/admin-reports-queries'
import { queryAndPreload } from '@web/src/lib/apollo/query-and-preload'
import { env } from '@web/src/lib/env.client'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'
import type { AdminReportCaseQuery } from 'types/graphql'

export const Route = createFileRoute('/(auth)/(admin-layout)/admin/reports/$caseId')({
  component: AdminReportCaseRoute,
  head: () =>
    seo({
      title: `Admin - Report Case | ${env.VITE_APP_NAME}`,
      description: 'Admin Report Case Page',
      robots: robotsMetaForEnvironment({ all: 'noindex,nofollow' }),
    }),
  loader: async ({ context, params }) => {
    const { queryRef } = await queryAndPreload(context, ADMIN_REPORT_CASE_QUERY, {
      variables: { id: params.caseId },
    })
    return { queryRef }
  },
})

function AdminReportCaseRoute() {
  const { caseId } = Route.useParams()
  const { queryRef } = Route.useLoaderData()
  return <AdminReportCasePanel caseId={caseId} queryRef={queryRef as QueryRef<AdminReportCaseQuery>} />
}
